import { render, staticRenderFns } from "./section6m.vue?vue&type=template&id=63d4af6f&scoped=true"
import script from "./section6m.vue?vue&type=script&lang=js"
export * from "./section6m.vue?vue&type=script&lang=js"
import style0 from "./section6m.vue?vue&type=style&index=0&id=63d4af6f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4af6f",
  null
  
)

export default component.exports